import React from "react";
import { useEffect } from "react";
import { useState } from "react";
const NewItem = ({ index, item, setItems, handleRemove }) => {
  const [newItem, setNewItem] = useState({
    ...item,
    product_name: "",
    quantity: "",
    net_price: "",
    total_price: "",
  });

  useEffect(() => {
    setItems((pre) => {
      const i = [...pre];
      i[index] = {
        ...i[index],
        ...newItem,
      };
      return i;
    });
  }, [newItem]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      <input
        type="text"
        name="product_name"
        placeholder="Product Name*"
        className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
        required
        value={newItem.product_name}
        onChange={(e) => {
          setNewItem({ ...newItem, [e.target.name]: e.target.value });
        }}
      />
      <input
        type="text"
        name="quantity"
        placeholder="Quantity*"
        className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
        required
        value={newItem.quantity}
        onChange={(e) =>
          setNewItem({ ...newItem, [e.target.name]: e.target.value })
        }
      />
      <input
        type="number"
        name="net_price"
        placeholder="Net Price*"
        className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
        required
        value={newItem.net_price}
        onChange={(e) =>
          setNewItem({ ...newItem, [e.target.name]: e.target.value })
        }
      />
      <input
        type="number"
        name="total_price"
        placeholder="Total Price*"
        className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
        required
        value={newItem.total_price}
        onChange={(e) =>
          setNewItem({ ...newItem, [e.target.name]: e.target.value })
        }
      />
      <a
        href="##"
        onClick={() => handleRemove(item.id)}
        className="btn btn-error md:mt-5 mt-0 text-white rounded-none"
      >
        Remove
      </a>
    </div>
  );
};

export default NewItem;
